<template>
    <el-dialog
      title="修改密码"
      :visible.sync="show"
      width="400px"
      :close-on-click-modal="false"
      @close="handleClose"
      destroy-on-close
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="登录密码" prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入6-12位密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="form.confirmPassword"
            type="password"
            placeholder="请再次输入密码"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </el-dialog>
  </template>
  
  <script>
  
  export default {
    name: 'EditPwd',
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    data() {
      const validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.form.password) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      return {
        form: {
          password: '',
          confirmPassword: ''
        },
        rules: {
          password: [
            { required: true, message: '请输入密码' },
            { min: 6, max: 12, message: '长度在 6 到 12 个字符' }
          ],
          confirmPassword: [
            { required: true, message: '请再次输入密码' },
            { validator: validatePass2 }
          ]
        }
      }
    },
    methods: {
      handleClose() {
        this.form.password = ''
        this.form.confirmPassword = ''
        this.$emit('close')
      },
      handleSubmit() {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            this.$emit('submit',  this.$utils.sha256Fn(this.form.password))
          }
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .dialog-footer {
    text-align: right;
  }
  </style> 